import { createFileRoute, Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import Footer from '@/components/footer'
import Header from '@/components/Header'
import ServiceGrid from '@/components/services/service-grid'

export const Route = createFileRoute('/_landing/services')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Header />

      {/* Page Banner */}
      <section className="relative h-[300px]">
        <img
          style={{ height: 300, width: 2500 }}
          src="/service.jpg"
          loading="lazy"
          alt="Guest House Services"
          className="object-cover"
        />
        <div className="absolute inset-0 bg-black/30 flex flex-col items-center justify-center text-white font-bold">
          <h1 className="text-4xl font-bold mb-4 text-primary">Our Services</h1>
          <div className="flex items-center gap-2">
            <Link href="/" className="hover:text-orange-500 transition-colors" to="/">
              Home
            </Link>
            <ChevronRight className="h-4 w-4" />
            <span>Services</span>
          </div>
        </div>
      </section>

      {/* Main Services Section */}
      <section className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-8 items-center mb-16">
          <div className="order-2 md:order-1">
            <img
              src="/room1.jpg"
              alt="Hotel Lobby"
              width={600}
              height={400}
              className="rounded-lg object-cover w-full h-auto"
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="text-3xl font-bold text-blue-700 mb-6">Accommodation</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                Our guest house offers a variety of comfortable rooms designed to provide a relaxing and enjoyable stay. Each room is equipped with modern amenities such as air conditioning, free Wi-Fi, flat-screen TVs, and luxury bedding. Whether you're visiting for a short getaway or an extended stay, you'll find our rooms are perfect for rest and relaxation.
              </p>
              <blockquote className="border-l-4 border-orange-500 pl-4 italic">
                "A truly unforgettable experience. The service was impeccable, and the room exceeded all expectations."
              </blockquote>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center mb-16">
          <div>
            <h2 className="text-3xl font-bold text-blue-700 mb-6">Reception & Concierge</h2>
            <div className="space-y-4 text-gray-600">
              <p>
                Our 24-hour reception and concierge team are here to ensure your stay is as comfortable and seamless as possible. Whether you need assistance with booking local tours, transportation, or arranging special requests, our staff is always ready to help. We pride ourselves on offering personalized service to make your stay truly memorable.
              </p>
              <blockquote className="border-l-4 border-orange-500 pl-4 italic">
                "The concierge team went above and beyond to make our visit extra special. Their recommendations for local dining and activities were spot on!"
              </blockquote>
            </div>
          </div>
          <div>
            <img
              src="/room1.jpg"
              alt="Hotel Reception"
              width={600}
              height={400}
              className="rounded-lg object-cover w-full h-auto"
            />
          </div>
        </div>

        {/* Service Grid */}
        <ServiceGrid />
      </section>

      <Footer />
    </>
  )
}
